import { ApplicationBracketsOutlineIcon } from './ApplicationBracketsOutlineIcon';

/**
 * author: Michael Richins
 * id 87F83807-58BE-49C5-981B-CBDFD8EABE4A
 * name application-brackets-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-brackets-outline.svg
 * tags
 * - Developer / Languages 
 */
export const IframeBracketsOutlineIcon = ApplicationBracketsOutlineIcon;
export default IframeBracketsOutlineIcon